import { toast } from 'react-toastify';

const useToastStore = {
  showToast: ({ message, type = 'success', duration = 3000, options = {} }) => {
    const toastOptions = {
      position: "top-right",
      autoClose: duration,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      ...options,
    };

    console.log("showToast", message, type, duration);
    let toast_id = null;
    switch (type) {
      case 'success':
        toast_id = toast.success(message, toastOptions);
        break;
      case 'error':
        toast_id = toast.error(message, toastOptions);
        break;
      case 'warning':
        toast_id = toast.warning(message, toastOptions);
        break;
      case 'info':
        toast_id = toast.info(message, toastOptions);
        break;
      default:
        toast_id = toast(message, toastOptions);
    }
    return toast_id;
  },
  hideToast: (toast_id) => {
    toast.dismiss(toast_id);
  }
};

export default useToastStore; 